// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-likes[data-v-5c9846a2]{display:flex;font-size:13px;font-weight:500;line-height:18px;margin-bottom:24px;overflow-x:scroll}.review-likes__item[data-v-5c9846a2]{align-items:center;color:#80869a;display:flex;flex-direction:column;list-style-type:none;margin-right:16px;opacity:.4;&.active[data-v-5c9846a2]{opacity:1}}.review-likes__text[data-v-5c9846a2]{color:#010d35}.Novikov .reviewModal__ratng-text[data-v-5c9846a2]{color:#0a0a0a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
